/*
*
* File JS per la Single Project Page
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockHero from 'components/block-hero/block-hero';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import blockDownload from 'components/block-download/block-download';

// COMPONENTI CUSTOM BLOCKS
import blockText from 'components/block-text/block-text';
import blockImage from 'components/block-image/block-image';
import scrollBanner from 'components/scroll-banner/scroll-banner';
import blockGallery from 'components/block-gallery/block-gallery';
import blockAltTextImage from 'components/block-alt-text-image/block-alt-text-image';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-project.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGallery();
blockVideo();

//--------------------------------------------------------------------//